<progress [max]="max" [value]="value" [ngClass]="color!"></progress>
